<template>
  <v-app>
    <v-system-bar 
      color="primary"
      height="36"
    >
      <span
        v-if="userLabel"
        class="userName"
      >Current User: {{ userLabel }}</span>
    </v-system-bar>

    <NavBar />

    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>

    <v-footer height="50">
      <FooterLinks />
    </v-footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import FooterLinks from "@/components/FooterLinks.vue";
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'

export default {
  name: "App",
  components: { NavBar, FooterLinks },
  data: () => ({
    userLabel: '',
    hubUnsub: null,
    routerUnreg: null,
  }),
  mounted() {
    document.title = "Deposit Service";
    this.loadUserLabel();

    // Listen for auth transitions (Amplify v6)
    this.hubUnsub = Hub.listen('auth', ({ payload }) => {
      const evt = payload?.event;
      if (evt === 'signedIn') this.loadUserLabel();
      if (evt === 'signedOut') this.userLabel = '';
    });

    // Also refresh on each navigation (helps after redirects)
    this.routerUnreg = this.$router.afterEach(() => this.loadUserLabel());
  },
  beforeUnmount() {
    try { this.hubUnsub?.(); } catch (e) { console.debug("hub unsubscribe failed", e); }
    try { this.routerUnreg?.(); } catch (e) { console.debug("router unregister failed", e); }
  },
  methods: {
    async loadUserLabel() {
      try {
        const { tokens } = await fetchAuthSession();
        if (!tokens) { this.userLabel = ''; return; } // signed out

        // Try username first
        let label = '';
        try {
          const { username } = await getCurrentUser();
          label = (username || '').split('_')[1];
        } catch { /* ignore; fall back to token claims */ }

        // Fall back to ID token claims (name/email)
        const claims = tokens.idToken?.payload || tokens.accessToken?.payload || {};
        if (!label) label = claims.name || claims.email || claims['cognito:username'] || '';

        this.userLabel = label || '';
      } catch {
        this.userLabel = '';
      }
    },
  }
};
</script>

<style>
.userName {
  font-size: small;
}
</style>